import styled from 'styled-components';
import { mb } from '@upgrade/react-components/Spacing/core';

export const List = styled.ul`
  ${mb('xl')};
  @media (min-width: ${props => props.theme.mediaSm}) {
    ${mb('lg')};
  }
  padding-inline-start: unset;
  list-style: none;
`;

export const Item = styled.li`
  ${mb('sm')};
  display: flex;
  align-items: ${({ iconBackgroundColor }) => (iconBackgroundColor ? 'center' : 'start')};
  gap: ${({ theme }) => theme.spacing.sm};
  list-style: none;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, iconBackgroundColor }) => theme.palette[iconBackgroundColor]};
  border-radius: 50%;
  padding: ${({ iconBackgroundColor }) => iconBackgroundColor && '0.5rem'};
`;
